import '../css/main.scss'
import 'bootstrap'
import './card-flip'
import './video-hover-preview'
import { constVoid, DOM, IOO, pipe, RNEA, RR, s, v } from '@packages/prelude'
import PhotoSwipe from 'photoswipe'
import Lightbox from 'photoswipe/lightbox'
import PhotoSwipeCaption from 'photoswipe-dynamic-caption-plugin'
import Swiper from 'swiper'
import { Autoplay, Navigation } from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(
      ({ document }) =>
        pipe(document, DOM.querySelectorAll(`.${selector}`)) as unknown as IOO.IOOption<RNEA.ReadonlyNonEmptyArray<HTMLElement>>
    ),
    IOO.fold(
      () => constVoid,
      elements =>
        IOO.of(
          pipe(
            elements,
            RNEA.map(element => new Swiper(element, options))
          )
        )
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  'customers-slider': {
    direction: 'horizontal',
    modules: [Autoplay],
    loop: true,
    autoplay: {
      delay: 5000
    },
    slidesPerView: 2,
    spaceBetween: 24,
    breakpoints: {
      576: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 4
      }
    }
  },
  'slideshow': {
    direction: 'horizontal',
    modules: [Autoplay, Navigation],
    loop: true,
    autoplay: {
      delay: 5000
    },
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      576: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)

document.addEventListener(
  'DOMContentLoaded',
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector('#lightbox-gallery'))),
    IOO.match(constVoid, () => {
      const leftArrowSVGString = '<i class="fa fa-angle-left fa-3x text-primary"></i>'
      const rightArrowSVGString = '<i class="fa fa-angle-right fa-3x text-primary"></i>'
      const closeSVGString = '<i class="fa fa-xmark fa-2x text-white"></i>'
      const lightbox = new Lightbox({
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: rightArrowSVGString,
        closeSVG: closeSVGString,
        gallerySelector: '#lightbox-gallery',
        childSelector: '.lightbox-gallery-item',
        zoom: false,

        showHideAnimationType: 'fade',
        initialZoomLevel: 'fit',

        imageClickAction: 'next',
        tapAction: 'next',

        closeTitle: 'Schließen',
        arrowPrevTitle: 'Zurück',
        arrowNextTitle: 'Vor',

        errorMsg: 'Das Bild konnte nicht geladen werden',
        indexIndicatorSep: ' von ',

        pswpModule: PhotoSwipe
      })

      new PhotoSwipeCaption(lightbox, {
        type: 'below',
        captionContent: 'figcaption'
      })

      lightbox.init()
    })
  )
)
